var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 582 329",
    style: {
      enableBackground: "new 0 0 582 329"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.2;fill:#02B2F8;}\n\t.st2{opacity:0.2;fill:#49DDFF;}\n\t.st3{opacity:0.2;fill:#0080CF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.4,87.7c-1.5,0-2.9,0.2-4.2,0.6c-3.6-6.2-10.4-10.4-18.1-10.4c-0.4,0-0.7,0-1.1,0.1 c-5.8-10.6-17-17.9-29.9-17.9c-12.5,0-23.4,6.7-29.3,16.7c-0.3,0-0.6,0-0.9,0c-13.2,0-23.9,10.7-23.9,23.9 c0,13.2,10.7,23.9,23.9,23.9c3.8,0,7.5-0.9,10.7-2.5c5.5,3.9,12.3,6.2,19.6,6.2c9.3,0,17.7-3.7,23.8-9.7c2.3,0.8,4.7,1.3,7.3,1.3 c5.7,0,10.9-2.3,14.7-6c2.2,1.4,4.8,2.2,7.6,2.2c7.8,0,14.2-6.3,14.2-14.2S442.2,87.7,434.4,87.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.6,196.5c-16.4-9.7-36.7-9.9-53.3-0.6l-40,22.5l-48,23.3L0,285.5L0.4,329h35.3h448.8l32.5-1.4l-151.3-69.7 L242.6,196.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97,227.7c-11.3-6.7-25.3-6.8-36.7-0.4L12,254.5l-11.6,5.6v68.7h303.8l-75.8-34.9L97,227.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M514.5,228.9c-14.1-7.9-31.3-7.7-45.2,0.5l-127.2,63.7l-77.5,35.8H582v-64.9L514.5,228.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.2,136c-0.4,0-0.8,0-1.2,0.1c-1.2-4.8-5.5-8.3-10.6-8.3c-3.9,0-7.3,2.1-9.2,5.1c-0.7-0.2-1.5-0.3-2.3-0.3 c-4.2,0-7.6,3.4-7.6,7.6c0,4.2,3.4,7.6,7.6,7.6c1.5,0,2.9-0.4,4.1-1.2c1.9,1.8,4.6,2.9,7.4,2.9c3,0,5.8-1.2,7.7-3.2 c1.1,1,2.5,1.6,4.1,1.6c3.3,0,6-2.7,6-6C495.2,138.7,492.5,136,489.2,136z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M551.1,95.2c-0.6,0-1.1,0.1-1.6,0.2c-1.5-6.3-7.2-10.9-13.9-10.9c-5.1,0-9.6,2.7-12.2,6.8 c-0.9-0.3-1.9-0.4-3-0.4c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10c2,0,3.8-0.6,5.3-1.6c2.6,2.4,6,3.9,9.8,3.9c4,0,7.6-1.6,10.2-4.3 c1.4,1.3,3.3,2.1,5.3,2.1c4.4,0,7.9-3.5,7.9-7.9C559,98.7,555.5,95.2,551.1,95.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.bc7a5081ac44f6595e3d5c511c9426ba.svg";
export { ForwardRef as ReactComponent };